import { Container, Grid, Section, Title } from '@/components/Core'
import { Lib } from '@/types'
import clsx from 'clsx'
import { readFragment } from 'gql.tada'
import { memo } from 'react'
import Client from './Client'
import SectionOfficeFragment from './query'

export interface SectionOfficeProps {
  data: Lib.FragmentOf<typeof SectionOfficeFragment>
}

const SectionOffice = ({ data }: SectionOfficeProps) => {
  const d = readFragment(SectionOfficeFragment, data)
  const { sectionPadding, hide, bg } = d

  const sectionClass = clsx(
    'py-section-md',
    hide && 'hidden',
    bg && 'bg-neutral-300'
  )
  return (
    <Section
      padding={sectionPadding}
      className={sectionClass}
      sectionName={d._modelApiKey}
      anim="section-fade-in"
    >
      <Container>
        <Grid>
          <div className="col-span-12 md:col-span-10 md:col-start-2">
            <Title as="h2">{d.title}</Title>
            <Client data={data} />
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default memo(SectionOffice)
